import $ from 'jquery'
global.$ = $
global.jQuery = $

require("@rails/ujs").start()

import 'bootstrap'
import WebpackerSvelte from "webpacker-svelte"
// import Home from "../src/components/Home.svelte"
import Quiz from "../src/components/Quiz.svelte"
// import LoginPage from "../src/components/LoginPage.svelte"

WebpackerSvelte.setup({ Quiz })

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-password-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.cbt-form__password-wrap').querySelector('input')
      const icon = button.querySelector('i')
      const isHidden = input.type === 'password'

      input.type = isHidden ? 'text' : 'password'
      icon.classList.toggle('fa-eye', !isHidden)
      icon.classList.toggle('fa-eye-slash', isHidden)
      button.setAttribute('aria-label', isHidden ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi')
    })
  })

  const container = document.getElementById('exam-sessions-list')
  if (!container) return

  const refreshUrl = container.dataset.refreshUrl
  const loginUrl = container.dataset.loginUrl || '/login'
  if (!refreshUrl) return

  const refreshExamSessions = () => {
    if (document.hidden) return

    fetch(refreshUrl, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (response.status === 401) {
          window.location.href = loginUrl
          return null
        }
        return response.ok ? response.text() : null
      })
      .then(html => {
        if (html) container.innerHTML = html
      })
      .catch(() => {})
  }

  setInterval(refreshExamSessions, 5000)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshExamSessions()
  })
})
// WebpackerSvelte.setup({ Home, Quiz })
// WebpackerSvelte.setup({ Home, LoginPage })